var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"margin-section"},[_c('div',{staticClass:"main-container"},[(_vm.payload.text)?_c('div',{staticClass:"mb-0 margin-top-main-text main-text",domProps:{"innerHTML":_vm._s(_vm.payload.text)}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }